<div>
  <div class="bdo-container bdo-section-headline">
    <bdo-section-headline>{{ 'dashboard.moreServices.title' | translate }}</bdo-section-headline>
  </div>

  <div class="bdo-container-notablet--single">
    <bdo-dashboard-tile
      [tileTitle]="'dashboard.moreServices.subtitle' | translate"
      >

      @if (!isRestricted) {
        <div class="re-mb-15">
          <bdo-text-link-icon
            [iconPosition]="'right'"
            [linkText]="'dashboard.moreServices.contractEnd' | translate"
            [routerUrl]="linkToSelection ? '/abmelden/' + accountId + '/auswahl' : '/abmelden/' + accountId "
            [tracking]="[TRACKING.LOCATION.DASHBOARD, TRACKING.ACTION.GOTO, TRACKING.LOCATION.CONTRACT_END_RECENT]"
          ></bdo-text-link-icon>
        </div>
      }
      <div class="re-mb-15">
        <bdo-text-link-icon
          data-qa="contact"
          [iconPosition]="'right'"
          [href]="reBaseData.hrefContact"
          [openInNewTab]="true"
          [linkText]="'dashboard.moreServices.contact' | translate"
          [tracking]="[TRACKING.LOCATION.DASHBOARD, TRACKING.ACTION.GOTO, TRACKING.LOCATION.CONTACT]"
          >
        </bdo-text-link-icon>
      </div>
      @if (reBaseData.hrefBillExplanation) {
        <div>
          <bdo-text-link-icon
            [iconPosition]="'right'"
            [href]="reBaseData.hrefBillExplanation"
            [openInNewTab]="true"
            [linkText]="'dashboard.moreServices.billExplanation' | translate"
            [tracking]="[TRACKING.LOCATION.DASHBOARD, TRACKING.ACTION.GOTO, TRACKING.LOCATION.EXTERNAL_BILL_EXPLANATION]"
            >
            </bdo-text-link-icon>
          </div>
      }
    </bdo-dashboard-tile>

  </div>
</div>
